import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { TextblockModel } from 'projects/core/src/lib/models/textblock.model';
import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { forkJoin } from 'rxjs';
import { LanguageModel } from 'projects/core/src/lib/models/language.model';
import { HelperService } from 'projects/admin/src/app/services/helper.service';

@Component({
  selector: 'app-textblock-detail',
  templateUrl: './textblock-detail.component.html',
  styleUrls: ['./textblock-detail.component.scss']
})
export class TextblockDetailComponent extends BaseDetail implements OnInit {

  public textblock: TextblockModel = null;
  public languages: Array<LanguageModel> = [];

  public backRoute = ['/contents/textblocks'];
  protected identifier = 'textblock';

  constructor(
    protected ui: UiService,
    protected router: Router,
    private api: ApiService,
    private route: ActivatedRoute,
    protected helper: HelperService,
    public transloco: TranslocoService
  ) {
    super(ui, router, helper, transloco);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params.id === 'new') {
        this.setInitialized(DetailModes.new);
      } else if (params.id) {
        this.setLoading();
        forkJoin([
          this.api.getModel('textblocks', params.id),
          this.api.getModels('languages'),
        ]).subscribe({
          next: (result: any) => {
            if (result[0].data) {
              this.textblock = new TextblockModel().deserialize(result[0].data);
            }
            if (result[1].data) {
              this.languages = result[1].data.map((language: any) => {
                return new LanguageModel().deserialize(language);
              });
            }
            this.tabIndex = parseInt(localStorage.getItem(this.identifier + '-tab'), 10);
            this.setInitialized(DetailModes.edit);
          },
          error: (error: any) => {
            this.setFailed(error);
          }
        });
      } else {
        this.onClose();
      }
    });
  }

}
